import React from 'react';
import { Box, Typography } from '@mui/material';
import { keyframes } from '@mui/system';
import { DESIGN_TOKENS } from '../../design-system/tokens';

// Animação de rotação para o círculo externo
const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

// Animação de pulso para o logo
const pulse = keyframes`
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.05);
    opacity: 0.9;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
`;

interface LoadingProps {
  message?: string;
  fullScreen?: boolean;
  transparentBackground?: boolean;
}

export const Loading: React.FC<LoadingProps> = ({ 
  message, // Mensagem agora é opcional e ignorada visualmente se não desejada, ou removida completamente
  fullScreen = true,
  transparentBackground = false
}) => {
  return (
    <Box
      sx={{
        position: fullScreen ? 'fixed' : 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: transparentBackground ? 'transparent' : 'rgba(0, 0, 0, 0.25)', // Fundo escuro original ou transparente
        backdropFilter: transparentBackground ? 'none' : 'blur(3px)', // Desfoque original ou nenhum
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999,
      }}
    >
      <Box
        sx={{
          position: 'relative',
          width: 120,
          height: 120,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        {/* Círculo animado externo */}
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            borderRadius: '50%',
            border: `3px solid transparent`,
            borderTopColor: DESIGN_TOKENS.colors.primary[500], // Cor primária da marca
            borderRightColor: DESIGN_TOKENS.colors.primary[300], // Variação mais clara
            animation: `${spin} 1.5s linear infinite`,
          }}
        />
        
        {/* Segundo círculo para efeito visual extra */}
        <Box
          sx={{
            position: 'absolute',
            top: 10,
            left: 10,
            width: 'calc(100% - 20px)',
            height: 'calc(100% - 20px)',
            borderRadius: '50%',
            border: `2px solid transparent`,
            borderBottomColor: DESIGN_TOKENS.colors.secondary[400], // Cor secundária
            animation: `${spin} 2s linear infinite reverse`,
          }}
        />

        {/* Logo Centralizado */}
        <Box
          component="img"
          src="/logo.svg"
          alt="MUU Logo"
          sx={{
            width: 60,
            height: 60,
            objectFit: 'contain',
            animation: `${pulse} 2s ease-in-out infinite`,
            zIndex: 1,
            // Mantém cor original se transparente, senão inverte para branco (comportamento original)
            filter: transparentBackground ? 'none' : 'brightness(0) invert(1)',
          }}
        />
      </Box>

      {/* Texto removido conforme solicitado */}
    </Box>
  );
};
